import React from 'react';
import '../components/Consultation.css';

const CALENDAR_BOOKING_URL =
  'https://calendar.app.google/nCF9xEsJKPQ3nfmr5';

const BOOKING_OPTIONS = [
  {
    title: 'Free Financial Need Analysis',
    subtitle:
      'Build a personalized strategy for protection, growth, and long-term financial confidence.',
    image: '/Images/image_1.jpeg',
    duration: '30 Min Session',
    price: 'Free',
    points: [
      'Insurance and protection review',
      'Retirement and legacy guidance',
      'Personalized one-to-one consultation',
    ],
    buttonText: 'Book Now',
  },
  {
    title: 'Free Financial Education for your Financial Planning',
    subtitle:
      'Learn how our business model works and explore income-building opportunities in financial services.',
    image: '/Images/Image_2.jpeg',
    duration: '30 Min Session',
    price: 'Free',
    points: [
      'Part-time or full-time options',
      'Training and mentorship support',
      'Clear next steps and guidance',
    ],
    buttonText: 'Book Now',
  },
  {
    title: 'Free Business Opportunity Presentation',
    subtitle:
      'Book one session to discuss both financial planning and business opportunity in one meeting.',
    image: '/Images/Image_3.jpeg',
    duration: '30 Min Session',
    price: 'Free',
    points: [
      'Combined consultation session',
      'Tailored advice for your goals',
      'Best-fit recommendation after review',
    ],
    buttonText: 'Book Now',
  },
];

const HOURS = [
  { day: 'Monday', time: '09:00 AM – 08:00 PM', status: 'open' },
  { day: 'Tuesday', time: '09:00 AM – 08:00 PM', status: 'open' },
  { day: 'Wednesday', time: '09:00 AM – 08:00 PM', status: 'open' },
  { day: 'Thursday', time: '09:00 AM – 08:00 PM', status: 'open' },
  { day: 'Friday', time: '09:00 AM – 08:00 PM', status: 'open' },
  { day: 'Saturday', time: 'By Appointment Only', status: 'appt' },
  { day: 'Sunday', time: 'By Appointment Only', status: 'appt' },
];

function getTodayName() {
  return new Date().toLocaleDateString('en-US', { weekday: 'long' });
}

function Consultation() {
  const today = getTodayName();

  const openBookingPopup = () => {
    window.open(
      CALENDAR_BOOKING_URL,
      'bookingPopup',
      'width=900,height=700,top=100,left=200,resizable=yes,scrollbars=yes'
    );
  };

  return (
    <div className="consult-page">
      <section className="consult-top-boxes">
        <div className="consult-top-boxes-inner">
          <div className="consult-top-boxes-heading">
            <div className="consult-hero-badge">
              <span className="consult-hero-badge-dot" />
              <span className="consult-hero-badge-text">
                Will to Wealth Financial Group
              </span>
            </div>

            <h1 className="consult-top-boxes-title">
              Choose Your Free <span>Consultation</span>
            </h1>

            <p className="consult-top-boxes-subtitle">
              Select the session that best matches your goals and book your
              one-to-one consultation today.
            </p>
          </div>

          <div className="consult-top-boxes-grid">
            {BOOKING_OPTIONS.map((option) => (
              <div key={option.title} className="consult-top-box">
                <div className="consult-top-box-image-wrap">
                  <img
                    src={option.image}
                    alt={option.title}
                    className="consult-top-box-image"
                  />
                  <div className="consult-top-box-image-overlay" />
                  <div className="consult-top-box-label">Free Session</div>
                </div>

                <div className="consult-top-box-content">
                  <div className="consult-top-box-meta">
                    <span className="consult-top-box-meta-pill">
                      ⏱ {option.duration}
                    </span>
                    <span className="consult-top-box-meta-pill free">
                      ✅ {option.price}
                    </span>
                  </div>

                  <h2 className="consult-top-box-title">{option.title}</h2>

                  <p className="consult-top-box-subtitle">{option.subtitle}</p>

                  <ul className="consult-top-box-list">
                    {option.points.map((point) => (
                      <li key={point}>{point}</li>
                    ))}
                  </ul>

                  <button
                    type="button"
                    className="consult-top-box-btn"
                    onClick={openBookingPopup}
                  >
                    {option.buttonText}
                    <span className="consult-top-box-btn-arrow">→</span>
                  </button>
                </div>
              </div>
            ))}
          </div>

          <p className="consult-top-boxes-note">
            <strong>
              Book Your FREE 1-on-1 Online Appointment with a Financial Expert
              Available in English, Hindi, and Gujarati. Schedule Now
            </strong>
          </p>
        </div>
      </section>

      <section className="consult-hours-map">
        <div className="consult-hours-map-inner">
          <div className="consult-hours-col">
            <div className="consult-hours-heading">
              <span className="consult-hours-eyebrow">Availability</span>
              <h2 className="consult-hours-title">
                Office &amp; Service <span>Hours</span>
              </h2>
              <p className="consult-hours-desc">
                We are available for consultations during the hours below.
                Weekend appointments are available — contact us to schedule.
              </p>
            </div>

            <div className="consult-hours-card">
              {HOURS.map(({ day, time, status }) => (
                <div
                  key={day}
                  className={`consult-hours-row ${day === today ? 'today' : ''}`}
                >
                  <span className="consult-hours-day">
                    {day === today ? `${day} ★` : day}
                  </span>
                  <span className="consult-hours-time">{time}</span>
                  <span className={`consult-hours-status ${status}`}>
                    {status === 'open' ? 'Open' : 'Appt'}
                  </span>
                </div>
              ))}
            </div>

            <div className="consult-hours-note">
              <span className="consult-hours-note-icon">💡</span>
              <span>
                All consultations are by appointment. Evening and weekend
                slots fill up fast — book early!
              </span>
            </div>
          </div>

          <div className="consult-map-col">
            <div className="consult-map-heading">
              <span className="consult-map-eyebrow">Service Area</span>
              <h2 className="consult-map-title">
                Serving All of New Jersey
              </h2>
              <p className="consult-map-desc">
                We serve families and individuals across New Jersey.
                In-person consultations available throughout the state —
                remote sessions available nationwide.
              </p>
            </div>

            <div className="consult-map-wrapper">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1555677.4386109674!2d-75.56957485!3d40.0583238!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c0fb959e00409f%3A0x2d2b6f8a8e4b8f1f!2sNew%20Jersey%2C%20USA!5e0!3m2!1sen!2sus!4v1710000000000!5m2!1sen!2sus"
                className="consult-map-iframe"
                title="Will to Wealth Service Area — New Jersey"
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Consultation;